interface TransferTooltipPlace {
  type: string;
  hasTransit: boolean;
  name: string;
  cityName: string;
}

function transferTooltipCopy({ type, hasTransit, name, cityName }: TransferTooltipPlace): string {
  let transferType: string;

  if (hasTransit) {
    if (type === 'terminal') {
      transferType = `trasladarte a la terminal: ${name}`;
    } else {
      transferType = `trasladarte al aeropuerto: ${name}`;
    }
  } else {
    transferType = `abordar otro ${type === 'terminal' ? 'autobús' : 'avión'} en la misma terminal`;
  }

  return `Para tomar la conexión es necesario ${transferType}, en ${cityName}`;
}

export { transferTooltipCopy };
